import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import Warning from '@material-ui/icons/Error';
import React from 'react';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#FFBC00',
    fontWeight: 600,
    color: '#192542',
  },
  icon: {
    color: '#192542',
  },
});

const DraftLabel = () => {
  const classes = useStyles();
  return <Chip size='small' className={classes.root} label='Rascunho' icon={<Warning className={classes.icon} />} />;
};

export default DraftLabel;
